import Vue, { VueConstructor } from 'vue';
import { NumberFormatResult } from 'vue-i18n';
import { getLocaleWithoutDialect } from './util';

export default function install(vue: VueConstructor<Vue>) {
    vue.prototype.$nds = function(value: number,
                                  formatName?: string,
                                  localeName?: string,
                                  ...args: any): NumberFormatResult {
        const locale = getLocaleWithoutDialect(this.$i18n.locale);

        return this.$i18n.n(value, formatName, localeName || locale, ...args);
    };
}
